const h = {
  name: "FormulaBenifitAllMerchants",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17,0v4h6v8h-3v4h-8v-4H9V4h6V0H17z M11,10h3v4h4v-4h3V6H11V10z"/>
		<path class="st0" d="M21,22h-3v4h-4v-4h-3v-6H0v24h32V16H21V22z M2,30h4v4h9v4H2V30z M8,32v-8h4v8H8z M2,28V18h7v4H6v6H2z M23,22
			v-4h7v14h-4V22H23z M20,24h4v8H14v-4h6V24z M17,34h13v4H17V34z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as FormulaBenifitAllMerchants
};
